<template>
	<div class="pageswitch">
		
		<div class="switch_area Flexalign" v-loading="loading">
			
			<div class="leftbtnicon Flexalign" v-show="prevbtnshow" >
				<i class="el-icon-d-arrow-left"></i>
			</div>
			
			<div class="switch_content FlexItem" >
				  <el-tabs class="eltabs" v-model="activeName">
					  <el-tab-pane  name="1">
					  	<template slot="label">
					  		<div class="btnicon2 FlexRow"
							 style="margin-right: 20px;"
							 @click="gotopage('/home/homepage')">
					  			<i class="iconfont icon-a-lujing19"></i>
					  		</div>
					  	</template>
					  </el-tab-pane>
				  	<el-tab-pane  :name="(index + 2) + ''" 
					v-for="(item, index) in pathlist">
				  		<template slot="label">
							<div class="switch_item FlexRow" :class="{'isActive': item.isActive}"
							 >
							  	<div class="switch_name" @click="gotopage(item.path, index)">
							  		{{item.title || ''}}
							  	</div>
							  	<div class="closeicon" @click="delelpaths(index)">
							  		<i class="el-icon-close"></i>
							  	</div>
							  </div>
							
						</template>
				  	</el-tab-pane>
				</el-tabs>
				
			</div>
			
			<div class="righbtnicon Flexalign" v-show="prevbtnshow">
				<i class="el-icon-d-arrow-right"></i>
			</div>
			
			<div class="switch_right Flexalign ">
				<el-dropdown trigger="click">
					<div class="btnicon2" >
						<i class="el-icon-arrow-down"></i>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item :command="1" :disabled="currentIndex==-1" @click.native="switchState(1)" >
							关闭当前标签页 
						</el-dropdown-item>
						<el-dropdown-item :command="2" :disabled="currentIndex==-1" @click.native="switchState(2)">
							关闭其他标签页
						</el-dropdown-item>
						<el-dropdown-item :command="3" :disabled="currentIndex==-1" @click.native="switchState(3)">
							关闭右侧标签页
						</el-dropdown-item>
						<el-dropdown-item :command="4" :disabled="currentIndex==-1" @click.native="switchState(4)">
							关闭全部标签页
						</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
		
		</div>
		
	</div>
</template>

<script>
	var that 
	export default {
		name:'pageswitch',
		props: {},
		components: {},
		watch: {
			// 路由页面发生变化时
			$route(to,from){
				if(to.path != '/home/homepage') {
					// 当前页面不是首页
					this.activeName = '0'
					this.routeChange(to)
				}
				else {
					this.clearIns()
				}
				this.currentPath = to.path || '';
			},
			// 显示高亮变化时
			currentIndex(){
				if(this.currentIndex != -1) {
					this.activeName = (this.currentIndex + 2) + '';
				}
			},
		},
		created(){
			this.getCachelist()
			that = this
			// 屏幕宽度变化时触发
			window.addEventListener('resize', that.fn_mountEch)
			this.deterprev()
		},
		methods: {
			// 获取标签缓存
			getCachelist(){
				let list = localStorage.CacheSwitchPage;
				let reslist = this.$retJSONArr(list)
				this.pathlist = this.$fn_retjson(reslist) || []
			},
			// 设置标签页缓存 
			setCachelist(){
				let list = JSON.stringify(this.pathlist)
				localStorage.setItem('CacheSwitchPage', list);
			},
			// 屏幕宽度变化时
			fn_mountEch(){
				this.deterprev(true)
			},
			// 由于使用的是 el-tabs 显示 ，清除默认样式，设置左右滑动 自定义 iconfont 图标
			deterprev(tflag){
				if(!this.$clickgate(1000, false)) return
				this.loading = true
				clearTimeout(this.timer)
				let time = tflag ? 0 : 600;
				this.timer = setTimeout(()=>{
					let navprev = document.querySelector('.el-tabs__nav-prev') || false
					let navnext = document.querySelector('.el-tabs__nav-next') || false
					if(navprev) {
						this.prevbtnshow = false
						let icon1 = navprev.querySelector('.el-icon-arrow-left')
						if(icon1) {
							if(icon1.className && icon1.className != 'el-icon-d-arrow-left') {
								icon1.className = 'el-icon-d-arrow-left'
							}
						}
					}
					else {
						this.prevbtnshow = true
					}
					if(navnext){
						let icon2 = navnext.querySelector('.el-icon-arrow-right')
						if(icon2) {
							if(icon2.className && icon2.className != 'el-icon-d-arrow-right') {
								icon2.className = 'el-icon-d-arrow-right'
							}
						}
					}
					this.loading = false
				}, time)
			},
			// 关闭当前
			delelpaths(index){
				this.pathlist.splice(index, 1)
				this.deterprev(true)
				let len = this.pathlist.length
				let path_index = -1
				if(index == len) {
					path_index = len - 1
				}
				else if(this.currentIndex == index) {
					path_index = index
				}
				if(path_index != -1 && this.pathlist[path_index]) { 
					let path = this.pathlist[path_index].path || ''
					let indnum = path_index
					this.gotopage(path, indnum)
				}
				this.setcurrentIn()
			},
			// 路由变化，清除所有高亮，设置当前路由高亮
			routeChange(e){
				if(e) {
					let {path} = e
					let hIndex = this.pathlist.findIndex(v=>v.path == path)
					for(let item of this.pathlist) {
						item.isActive = false
					}
					if(hIndex != -1) { //已存在
						this.pathlist[hIndex].isActive = true
					}
					else {  //
						let title_Txt = e.meta.title
						let arr1 = title_Txt.split('-')
						if(arr1[0] && arr1[0] != '没有授权') {
							let newEle = {
								path,
								title: arr1[0],
								isActive: true,
							}
							this.pathlist.push(newEle)
						}
						this.deterprev()
					}
				}
				this.setcurrentIn()
			},
			// 批量操作
			switchState(flag){
				if(this.currentIndex == -1) return
				if(flag == 1) { // 关闭当前标签页   
					this.delelpaths(this.currentIndex)
				}
				else if(flag == 2) {  // 关闭其他标签页
					let newObj = this.fn_retjson(this.pathlist[this.currentIndex])
					this.pathlist = [newObj]
					this.prevbtnshow = true
				}
				else if(flag == 3) {  // 关闭右侧标签页
					let newArr = this.pathlist.slice(0, this.currentIndex + 1)
					this.pathlist = newArr
					this.prevbtnshow = true
				}
				else if(flag == 4) {  // 关闭全部标签页
					this.pathlist = []
					this.prevbtnshow = true
				}
				this.setCachelist()
			},
			// 清空所有选中状态
			clearIns(){
				for(let item of this.pathlist) {
					item.isActive = false
				}
				this.currentIndex = -1
				this.setCachelist()
			},
			// 获取当前 选中索引
			setcurrentIn(){
				this.currentIndex = this.pathlist.findIndex(v=>v.isActive == true)
				this.setCachelist()
			},
			// 去往对应路由页面
			gotopage(path, index){
				if(index != undefined) {
					this.currentIndex = index
				}
				if(this.currentPath == path) return;
				this.$router.push({
					path,
					query: {},
				});
			},
			fn_retjson(obj) {
				if(obj != undefined) {
					return JSON.parse(JSON.stringify(obj))
				}
				else {
					return ''
				}
			}
		},
		data() {
			return {
				activeName: '1',
				pathlist: [],  
				currentIndex: -1,
				prevbtnshow: true,
				currentPath: '',
				timer: null,
				loading: false,
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../assets/css/projecticon.css";
	.pageswitch{
		width: 100%;
		// min-width: 1240px;
		
		background: rgba(255, 255, 255, 1);
		border-bottom: solid 1px rgba(237, 241, 244, 1);
		position: sticky;
		top: 1px; 
		z-index: 99;
	}
	.btnicon2:hover{
		i{
			color:var(--themeColors);
		}
	}
	.btnicon2{
		height: 100%;
	}
	
	.leftbtnicon, .righbtnicon{
		position: absolute;
		z-index: 200;
		cursor: pointer;
		i{
			font-size: 14px;
			color: #909399;
		}
	}
	.leftbtnicon{
		left: 28px;
	}
	.righbtnicon{
		right: 90px;
	}
	.switch_area{
		height: 50px;
		width: 100%;
		position: relative;
		
		.switch_content{
			height: 50px;
			max-width: calc(100% - 65px);
			
			.switch_item.isActive{
				height: 50px;
				border-radius: 0;
			}
			.switch_item.isActive::before{
				width: 100%;
			}
			.switch_item::before{
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				height: 3px;
				width: 0%;
				transition: all .3s;
				background: rgba(43, 117, 235, 1);
			}
			.switch_item:hover{
				&::before{
					width: 100%;
				}
			}
			
			.switch_item{
				background: rgba(245, 246, 248, 1);
				cursor: pointer;
				// border:solid 1px red;
				position: relative;
				min-width: 92px;
				padding: 0 8px;
				border-radius: 3px;
				
				.switch_name{
					font-size: 13px;
					font-weight: 400;
					color: rgba(46, 64, 94, 1);
				}
				.closeicon:hover{
					i{
						color:red;
					}
				}
				
				.closeicon{
					margin-left: 1px;
					i{
						font-size: 14px;
					}
				}
			}
		}
		.switch_right{
			min-width: 60px;
		
			.btnicon2{
				cursor: pointer;
				margin: 0;
				i{
					font-size: 14px;
				}
			}
		}
	}

	/deep/ .el-tabs__nav-prev{
		
		padding: 0 26px ;
		padding-top: 3px;
		i{
			
			font-size: 14px;
		}
	}
	// /deep/ .el-tabs{
	// 	min-width: 960px;
	// }
	/deep/ .el-tabs__nav-wrap::after{
		display: none !important; 
	}
	/deep/ .el-tabs__nav-next{
		
		padding: 0 26px ;
		padding-top: 3px;
		i{
		
			
			font-size: 14px;
		}
	}
	/deep/ .el-tabs__nav-scroll{
		height: 50px !important;
	}
	/deep/ .el-tabs__nav-wrap{
		padding: 0 65px !important;
	}
	/deep/ .el-tabs.eltabs {
		.el-tabs__active-bar {
			display: none !important;
		}
		
		
	
		.el-tabs__header {
			background: #ffffff;
			margin: 0;
			border-bottom: none;
			position: sticky;
			top: 0;
			z-index: 1;
		}
	
		.el-tabs__item {

			height: 50px;
			padding: 0px;
			margin-right: 5px;
		}
	
		.el-tabs__content {
			display: none !important;
		}
	}
	  
</style>